import GenreService from '@/common/api/genre'
import {
  GET_GENRE_ACTORS
} from './actions'
import {
  FETCH_ACTORS_LIST
} from './mutations'

const state = {
  actorsList: []
}

const getters = {
  actorsList (state) {
    return state.actorsList
  }
}

const actions = {
  [GET_GENRE_ACTORS] (context, { type, id, params = {} }) {
    return new Promise((resolve, reject) => {
      GenreService.actors(type, id, params)
        .then(({ data }) => {
          context.commit(FETCH_ACTORS_LIST, data)
          resolve(data)
        })
        .catch(error => {
          context.commit(FETCH_ACTORS_LIST, null)
          reject(error)
        })
    })
  }
}

const mutations = {
  [FETCH_ACTORS_LIST] (state, data) {
    state.actorsList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
